<app-side-menu>
<div class="checklist-list-container">
  <!-- Header -->
  <div class="page-header">
    <div class="header-content">
      <h1><i class="fas fa-clipboard-check"></i> Checklists</h1>
      <p class="subtitle">Gerencie e visualize todos os checklists do sistema</p>
    </div>
  </div>

  <!-- Filtros -->
  <div class="filters-section">
    <div class="filters-row">
      <div class="filter-group">
        <label for="statusFilter" class="form-label">Filtrar por Status:</label>
        <select id="statusFilter" class="form-select" [(ngModel)]="selectedStatus" (change)="onFilterChange()">
          <option value="">Todos os status</option>
          <option *ngFor="let s of statusOptions" [value]="s.value">{{s.label}}</option>
        </select>
      </div>
      <div class="filter-group">
        <label for="typeFilter" class="form-label">Filtrar por Tipo:</label>
        <select id="typeFilter" class="form-select" [(ngModel)]="selectedType" (change)="onFilterChange()">
          <option value="">Todos os tipos</option>
          <option *ngFor="let t of checklistTypes" [value]="t.value">{{t.label}}</option>
        </select>
      </div>
      <div class="filter-actions">
        <button type="button" class="btn btn-outline-secondary" (click)="clearFilters()">
          <i class="fas fa-times me-2"></i>
          Limpar Filtros
        </button>
      </div>
    </div>
  </div>

  <!-- Mensagem de erro -->
  <div *ngIf="error" class="alert alert-danger" role="alert">
    <i class="fas fa-exclamation-circle"></i> {{ error }}
  </div>

  <!-- Loading -->
  <!-- Tabela de checklists (sempre visível quando não há erro) -->
  <div *ngIf="!error">
    <app-table
      #tableComponent
      [title]="'Listagem de Checklists (' + totalCount + ')'"
      [data]="data"
      [columns]="columns"
      [loading]="isLoading"
      [actions]="actions"
      [showSearch]="true"
      [searchPlaceholder]="'Pesquisar checklists...'"
      [searchTerm]="searchTerm"
      [clickable]="false"
      [itemsPerPage]="pageSize"
      [totalItemsFromBackend]="backendPaginationTotal"
      [hasNextPageFromBackend]="hasNextPage"
      [hasPreviousPageFromBackend]="hasPreviousPage"
      [currentPageFromBackend]="currentPage"
      [enableSorting]="true"
      (sortChange)="onSortChange($event)"
      (actionClick)="onActionClick($event)"
      (searchChange)="onTableSearchChange($event)"
      (pageChange)="onTablePageChange($event)"
      (pageSizeChange)="onTablePageSizeChange($event)">
      <button *appHasPermission="'Checklist.Create'" table-header-action class="btn btn-primary btn-new" (click)="onNew()">
        <i class="fas fa-plus"></i> Novo Checklist
      </button>
    </app-table>
  </div>
</div>
</app-side-menu>


